var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kpt-document-search-results",class:{ 'more-than-3': _vm.results.length > 3 }},[(_vm.results.length)?_c('div',_vm._l((_vm.results),function(result,idx){return _c('document-result',{key:idx,attrs:{"result":result},on:{"null-search":_vm.nullSearch}})}),1):_c('div',[_vm._v("No results found for your query.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }